// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 12:30 AM
 */
import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {
    EBadgeActionButtonDispatchProps,
    EBadgeActionButtonOwnProps,
    EBadgeActionButtonStateProps
} from "../../components/ebadge/EBadgeActionButton";
import EBadgeActionButton from "../../components/ebadge/EBadgeActionButton";
import {extractCaller} from "../QueryPage";
import {openEBadgeButtonModalAction} from "../../actions/ebadge/creators/eBadgeButtonActionCreator";

function getIsLoadingStatus(state: StoreState, registrationCode) {
    let status = state.eBadgeAction['invalidate'] && state.eBadgeAction['invalidate'][registrationCode];
    if (status) {
        return status.isLoading;
    } else {
        return false;
    }
}

const mapStateToProps = (state: StoreState, ownProps: EBadgeActionButtonOwnProps): EBadgeActionButtonStateProps => {
    const registrationCode = ownProps.registrationCode;
    const isLoading = getIsLoadingStatus(state, registrationCode);
    return {
        isLoading,
        caller: extractCaller(state),
        roleIds: state.loginUser.roleIds
    };
};

const mapDispatchToProps = (dispatch): EBadgeActionButtonDispatchProps => {
    return {
        onClick: (registrationCode: string) => {

            dispatch(openEBadgeButtonModalAction(registrationCode, "invalidate"));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(EBadgeActionButton);



// WEBPACK FOOTER //
// ./src/containers/ebadge/InvalidateEBadgeButton.js